import { render, staticRenderFns } from "./GCompetencyHeader.vue?vue&type=template&id=2a46c6e5&scoped=true&"
import script from "./GCompetencyHeader.vue?vue&type=script&lang=ts&"
export * from "./GCompetencyHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a46c6e5",
  null
  
)

export default component.exports